import SubScriptionManagerSSO from "./subscriptionmanagersso";
import { AUTHENTICATED } from "./../../common/analytics/analyticsevents";

//Authentication used by LUX and ALO. Can be modified to support Auth0

const cookieExpirationTimeInMinute = 10;
export default class SubscriptionManagerState extends SubScriptionManagerSSO {
  constructor(
    appState,
    sessionManager,
    apiManager,
    cookieManager,
    options = {}
  ) {
    super(appState, sessionManager, apiManager, cookieManager, options);
  }

  getSSOState() {
    /*
     This cookie is created to store the redirection url, sso token and a timestamp called state
     that is used to check the validity of the token
     that will be used when coming back from client paywall
    */

    const stateCookieValue = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.SSO_STATE
    );
    if (stateCookieValue && stateCookieValue !== "") {
      return JSON.parse(stateCookieValue).state;
    }
    return;
  }

  getSSOStateCookieExpirationTimeInMs = () => {
    const currentDate = new Date();
    const tenMinuteFromNow =
      currentDate.getTime() + cookieExpirationTimeInMinute * 60 * 1000;

    return tenMinuteFromNow;
  };

  getRandomTokenWithTimeStamp = () => {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15) +
      "-" +
      Date.now()
    );
  };

  getStateFromUrl = () => {
    return this.getURLParameterValue("state");
  };

  isStateCreatedWithinTenMinutes = (state) => {
    const stateTimestamp = state.split("-")[1];
    const stateTimeStampInSeconds = parseInt(Math.floor(stateTimestamp / 1000));
    const stateTimeStampInMinutes = parseInt(
      Math.floor(stateTimeStampInSeconds / 60)
    );

    const now = parseInt(Math.floor(Date.now() / 1000));
    const nowInMinutes = parseInt(Math.floor(now / 60));

    return nowInMinutes - stateTimeStampInMinutes < 10;
  };

  /* We ensure that the state is the same as the state created whe we created the redirection url */
  isOriginalState = (state) => {
    const originalState = this.getSSOState();
    return state === originalState;
  };

  isValidState = (state) => {
    return (
      state &&
      this.isStateCreatedWithinTenMinutes(state) &&
      this.isOriginalState(state)
    );
  };

  removeSSOStateCookie(force = true) {
    const stateCookieValue = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.SSO_STATE
    );
    if (stateCookieValue && force) {
      this._cookieManager.removeCookie(
        this._cookieManager.cookieKeys.SSO_STATE,
        {
          expires: -1,
          path: "/",
        }
      );
    }
  }

  redirect() {
    const stateCookieValue = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.SSO_STATE
    );
    if (stateCookieValue) {
      const redirectUrl = JSON.parse(stateCookieValue).redirectUrl;
      if (redirectUrl && redirectUrl != null) {
        this.removeSSOStateCookie(true);
        window.location.href = decodeURIComponent(redirectUrl);
      }
    }
  }

  handleAuthenticationSuccess(data) {
    // store subscriptionCookie
    this._createSubscriptionCookie(
      data.SubscriptionID,
      data.SubscriptionReference,
      data.SubscriptionUserReference,
      data.SubscriptionType
    );
    this.trigger("subscriptionmanager:authenticationstatuschanged");
    this.redirect();
  }

  setSSOState(redirectUrl) {
    const stateCookieValue = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.SSO_STATE
    );

    const cookieExpirationTimeInMs = this.getSSOStateCookieExpirationTimeInMs();

    if (!stateCookieValue) {
      this._cookieManager.createCookie(
        this._cookieManager.cookieKeys.SSO_STATE,
        JSON.stringify({
          state: this.getRandomTokenWithTimeStamp(),
          redirectUrl: redirectUrl,
        }),
        {
          expires: cookieExpirationTimeInMs,
          path: "/",
          useTime: true,
        }
      );
    } else {
      /* To avoid always being redirected to the home even when we click on a publication we always update the url stored in the state cookie */
      if (redirectUrl && redirectUrl != "") {
        const cookieSSOState = JSON.parse(stateCookieValue).state;
        this.removeSSOStateCookie(true);
        this._cookieManager.createCookie(
          this._cookieManager.cookieKeys.SSO_STATE,
          JSON.stringify({
            state: cookieSSOState,
            redirectUrl: redirectUrl,
          }),
          {
            expires: cookieExpirationTimeInMs,
            path: "/",
            useTime: true,
          }
        );
      }
    }
  }

  authenticate = (downloadToken) => {
    const authenticationPromise = new Promise((resolve, reject) => {
      const authToken = this.getToken();
      const state = this.getStateFromUrl();

      if (authToken && (!state || this.isValidState(state))) {
        this.validateAuthToken(authToken, downloadToken)
          .then((response) => {
            if (response) {
              if (response.Status.toLowerCase() === "success") {
                this.handleAuthenticationSuccess(response);
                this._appState.triggerEvent(AUTHENTICATED);
                resolve(response);
              } else {
                this.removeSSOCookie(true);
                this.removeSSOStateCookie(true);
                this.handleValidateAuthTokenFailed(response, reject);
              }
            }
          })
          .catch((error) => {
            this.removeSSOStateCookie(true);
            reject(error);
          });
      } else {
        reject("invalid token");
      }
    });

    return authenticationPromise;
  };
}



// WEBPACK FOOTER //
// ./src/common/subscriptionmanagement/subscriptionManagerState.js